exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box-wrapper {\r\n  padding: 11px 7px;\r\n  margin-bottom: 5px;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\n}\r\n", ""]);

// exports
